var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{attrs:{"src":_vm.source,"contain":"","max-height":32}})}
var staticRenderFns = []

export { render, staticRenderFns }